import client from '../client';
import type { StorePage, StandardPage, CreatePageInput, UpdatePageInput } from '../../types/page';
import type { ApiResponse } from '../../types/api';

export const pagesApi = {
  list: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ customPages: StorePage[]; standardPages: StandardPage[] }>>(
      `/dashboard/${storeId}/pages`,
    );
    return res.data.data!;
  },

  get: async (storeId: string, pageId: string) => {
    const res = await client.get<ApiResponse<{ page: StorePage }>>(
      `/dashboard/${storeId}/pages/custom/${pageId}`,
    );
    return res.data.data!;
  },

  create: async (storeId: string, data: CreatePageInput) => {
    const res = await client.post<ApiResponse<{ pageId: string }>>(
      `/dashboard/${storeId}/pages/custom`,
      data,
    );
    return res.data.data!;
  },

  update: async (storeId: string, pageId: string, data: UpdatePageInput) => {
    await client.patch(`/dashboard/${storeId}/pages/custom/${pageId}`, data);
  },

  delete: async (storeId: string, pageId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/pages/custom/${pageId}`);
  },

  listBlogPosts: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ posts: StorePage[] }>>(
      `/dashboard/${storeId}/pages/blog`,
    );
    return res.data.data!;
  },

  listVersions: async (storeId: string, pageId: string) => {
    const res = await client.get<ApiResponse<{ versions: Array<{ _id: string; title: string; updatedAt: string; updatedBy?: string }> }>>(
      `/dashboard/${storeId}/pages/custom/${pageId}/versions`,
    );
    return res.data.data!;
  },

  restoreVersion: async (storeId: string, pageId: string, versionId: string) => {
    await client.post(`/dashboard/${storeId}/pages/custom/${pageId}/versions/${versionId}/restore`);
  },

  listAttachments: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ attachments: Array<{ _id: string; fileName: string; originalName: string; type: string; createdAt: string }> }>>(
      `/dashboard/${storeId}/pages/attachments`,
    );
    return res.data.data!;
  },

  uploadAttachment: async (storeId: string, data: { file: string; fileName: string; type?: string }) => {
    const res = await client.post<ApiResponse<{ attachmentId: string; fileName: string; url: string }>>(
      `/dashboard/${storeId}/pages/attachments`,
      data,
    );
    return res.data.data!;
  },

  deleteAttachment: async (storeId: string, attachmentId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/pages/attachments/${attachmentId}`);
  },
};
